import React from "react";
import cx from "classnames";
import {createUseStyles} from "react-jss";
import {Answer} from "./Answer";
import {SafeRichTextRenderer} from "../common/richText/SafeRichTextRenderer";

const useStyles = createUseStyles(() => ({
    resultQuestion: {
        paddingBottom: 20,
        width: "100%",
        maxWidth: "576px",
    },
    headerRow: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-start",
        gap: 12,
        paddingBottom: 16,
    },
    resultQuestionDef: {
        fontWeight: "bold",
        fontSize: "1.1rem",
        flex: 1,
    },
    statusBadge: {
        padding: "4px 12px",
        borderRadius: "999px",
        fontSize: "0.875rem",
        fontWeight: "bold",
        textTransform: "uppercase",
        letterSpacing: "0.05em",
    },
    badgeCorrect: {
        backgroundColor: "rgba(74, 222, 128, 0.15)",
        color: "#4ade80",
        border: "1px solid #4ade80",
    },
    badgeIncorrect: {
        backgroundColor: "rgba(248, 113, 113, 0.15)",
        color: "#f87171",
        border: "1px solid #f87171",
    },
    resultQuestionAlternatives: {
        display: "flex",
        flexDirection: "column",
        gap: 8,
        paddingBottom: 16,
    },
    explanationContainer: {
        marginTop: 12,
        padding: "16px 20px",
        backgroundColor: "rgba(255, 255, 255, 0.08)",
        borderLeft: "4px solid #4ade80",
        borderRadius: 8,
    },
    explanationTitle: {
        fontWeight: "bold",
        fontSize: "1rem",
        marginBottom: 8,
        color: "#4ade80",
    },
}));

export const Question = ({question, index = 0}) => {
    const yourAnswer = (question?.answers || []).find(a => a.uniqueId === question.selectedAnswerUniqueId);
    const classes = useStyles();
    const activeAnswers = (question?.answers || []).filter(a => a && a.active !== false);
    const hasDetails = Boolean(question?.details && typeof question.details === "string" && question.details.trim().length > 0);
    const isCorrect = Boolean(yourAnswer && yourAnswer.correct);

    return (
        <div key={question?.uniqueId} className={classes.resultQuestion}>
            <div className={classes.headerRow}>
                <div className={classes.resultQuestionDef}>
                    {question?.content}
                </div>
                <span
                    data-testid={`result-question-status-${index ?? 0}`}
                    className={cx(classes.statusBadge, isCorrect ? classes.badgeCorrect : classes.badgeIncorrect)}
                >
                    {isCorrect ? "Riktig" : "Feil"}
                </span>
            </div>
            <div className={classes.resultQuestionAlternatives}>
                {activeAnswers.map((answer, idx) => (
                    <Answer
                        key={answer.uniqueId}
                        answer={answer}
                        idx={idx}
                        yourAnswer={yourAnswer}
                    />
                ))}
            </div>
            {hasDetails && (
                <div className={classes.explanationContainer}>
                    <div className={classes.explanationTitle}>Forklaring</div>
                    <SafeRichTextRenderer text={question.details} />
                </div>
            )}
        </div>
    );
};
